export const types = Object.freeze({
    FEATURE_FLAGS_REQUEST: 'featureFlags/FEATURE_FLAGS_REQUEST',
    FEATURE_FLAGS_REFRESH_REQUEST: 'featureFlags/FEATURE_FLAGS_REFRESH_REQUEST',
    FEATURE_FLAGS_SUCCESS: 'featureFlags/FEATURE_FLAGS_SUCCESS',
    FEATURE_FLAGS_ERROR: 'featureFlags/FEATURE_FLAGS_ERROR',
    CLEAR_FEATURE_FLAGS: 'featureFlags/CLEAR_FEATURE_FLAGS',
});
